module.exports = __webpack_public_path__ + "img/BlendBuff-AbnormalProbabilityUp.59631592.png";